// extracted by mini-css-extract-plugin
module.exports = {"summaryHeader":"BillSummary_summaryHeader__GZxze","dialogContent":"BillSummary_dialogContent__2Rq-7"};